module.exports = __webpack_public_path__ + "img/meg.eed7adb5.png";